<template>
  <div>

    <div style="background-color: #F5F5F5">
      <div>
        <v-btn class="mx-2 mt-2" color="primary" depressed @click="back">返回</v-btn>
        <v-btn color="primary" class="mr-2 mt-2" depressed @click="save">提交</v-btn>
      </div>
      <v-form ref="appointmentForm">
        <div style="position: relative">
          <v-card class="ma-2" elevation="0">
            <v-card-title>基础信息</v-card-title>
            <v-card-text>
              <v-row align="center" class="text-h6">
                <v-col cols="3">
                  <vender-select label="供应商" v-model="appointment.venderId" :rules="[rules.required]"></vender-select>
                </v-col>
                <v-col cols="3">
                  <park-select label="配送中心" v-model="appointment.parkId" :rules="[rules.required]" :vender-id="appointment.venderId"></park-select>
                </v-col>
                <v-col cols="1">
                  送货时间段
                </v-col>
                <v-col cols="2">
                  {{ appointment.sendStartTime }}~{{ appointment.sendEndTime }}
                </v-col>
                <v-col cols="3">
                  <date-picker label="预约送达日期" v-model="appointment.scheduledDate" :rules="[rules.required,rules.appointDate]"></date-picker>
                </v-col>
                <v-col cols="3">
                  <v-select label="卸货方式" :items="dischargeTypeList" item-value="id" item-text="name" outlined dense clearable :rules="[rules.required]" v-model="appointment.dischargeType"/>
                </v-col>
                <v-col cols="3" >
                  <v-select label="预约时段" :items="timeTypeList" item-value="id" item-text="name" outlined dense clearable :rules="[rules.required]" v-model="appointment.timeType"></v-select>
                </v-col>
                <v-col cols="1" v-if="formData.addType == 2">
                  <v-text-field label="总箱数" outlined dense v-model="appointment.boxNum" :rules="[rules.number]"></v-text-field>
                </v-col>
                <v-col cols="1" v-if="formData.addType == 2">
                  <v-text-field label="吨数" outlined dense v-model="appointment.tonNum" :rules="[rules.number]"></v-text-field>
                </v-col>
                <v-col cols="1" v-if="formData.addType == 2">
                  <v-text-field label="sku数" outlined dense v-model="appointment.skuNum" :rules="[rules.required,rules.number]"></v-text-field>
                </v-col>
              </v-row>
              <div v-if="formData.addType == 1 || formData.addType == 3">
                <v-row>
                  <v-col>
                    <v-btn depressed color="primary" @click="linkOrder">关联订单</v-btn>
                  </v-col>
                </v-row>
                <v-data-table :headers="orderHeaders" :items="appointment.orderList" hide-default-footer :items-per-page="-1">
                  <template v-slot:item.actions="{ item,index }">
                    <v-btn text color="primary" small @click="watchOrderGoods(item)">查看货品明细</v-btn>
                    <v-btn text color="primary" small @click="deleteOrder(index)">删除</v-btn>
                  </template>
                </v-data-table>
              </div>
              <div v-if="formData.addType == 2">
                <v-row>
                  <v-col>
                    <v-btn depressed color="primary" @click="linkGoods">关联商品</v-btn>
                    <v-btn depressed color="primary" class="ml-2" @click="doGoodsImport">导入商品</v-btn>
                  </v-col>
                </v-row>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <td>商品条码</td>
                        <td>商品名称</td>
                        <td>包装规格</td>
                        <td>单位</td>
                        <td>本次发货数量</td>
                        <td>操作</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(goods,i) in appointment.goodsList">
                        <td>{{goods.barcode}}</td>
                        <td>{{goods.goodsname}}</td>
                        <td>{{goods.packagespec}}</td>
                        <td>{{goods.pkname}}</td>
                        <td><v-text-field outlined dense v-model="goods.deliveryNum" :rules="[rules.required,rules.number]" style="max-width: 150px"></v-text-field></td>
                        <td><v-btn text color="primary" class="pa-0" @click="deleteGoods(i)">删除</v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="ma-2" elevation="0">
            <v-card-title>审核信息</v-card-title>
            <v-card-text>
              <v-data-table :items="appointment.auditRecordList" :headers="auditHeaders" :items-per-page="-1" hide-default-footer>
                <template v-slot:item.auditResult="{ item,index }">
                  {{ auditResultList[item.auditResult - 1].name }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-form>
    </div>

    <v-dialog v-model="order.dialog" width="1000">
      <v-card>
        <v-card-title>
          关联订单
          <v-spacer></v-spacer>
          <v-text-field
              v-model="order.search"
              append-icon="mdi-magnify"
              label="订单号"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
            v-model="order.selected"
            :headers="order.headers"
            :search="order.search"
            :loading="order.loading"
            :items="order.desserts"
            show-select
            item-key="ordercode"
        >
          <template v-slot:item.status="{ item }">
            {{ item.status=='Y'?'已确认':'未确认' }}
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="order.dialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="selectOrder"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-overlay :value="order.overlay">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="orderItem.dialog">
      <v-card>
        <v-card-title>
          货品明细
        </v-card-title>
        <v-form ref="itemForm">
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <td>商品名称</td>
              <td>商品代码</td>
              <td>商品条码</td>
              <td>件装数</td>
              <td>总件数</td>
              <td>总数量</td>
              <td>未发件数</td>
              <td>未发数量</td>
              <td>本次发货件数</td>
              <td>本次发货数量</td>
              <td>是否发货完结</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="ordD in orderItem.item.itemList">
              <td>{{ordD.pn}}</td>
              <td>{{ordD.procode}}</td>
              <td>{{ordD.barcode}}</td>
              <td>{{ordD.num}}</td>
              <td>{{ordD.innums}}</td>
              <td>{{ordD.denums}}</td>
              <td>{{ordD.undeliveryInnums}}</td>
              <td>{{ordD.undeliveryDenums}}</td>
              <td><v-text-field outlined dense v-model="ordD.thisInnums" @input="innumsChange($event, ordD)" :rules="[rules.required,rules.number]"></v-text-field></td>
              <td><v-text-field outlined dense v-model="ordD.thisDenums" @input="denumsChange($event, ordD)" :rules="[rules.required,rules.number]"></v-text-field></td>
              <td><v-select outlined dense v-model="ordD.isComplete" :items="orderItem.completeList" item-value="id" item-text="name"></v-select></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="orderItem.dialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="saveItem"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="goods.dialog" width="800">
      <v-card>
        <v-card-title>
          关联商品
          <v-spacer></v-spacer>
          <v-text-field
              v-model="goods.search"
              append-icon="mdi-magnify"
              label="搜索内容"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
            v-model="goods.selected"
            :headers="goods.headers"
            :search="goods.search"
            :loading="goods.loading"
            :items="goods.desserts"
            show-select
            item-key="barcode"
        >
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="goods.dialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="selectGoods"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="importGoods.dialog" width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"
        >导入商品
        </v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-file-input
                    truncate-length="15"
                    label="选择excel"
                    small-chips
                    dense
                    v-model="importGoods.importFile"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="handleImport"> 确认</v-btn>
          <v-btn color="primary" text @click="downloadTemplate">
            下载模板
          </v-btn>
          <v-btn text @click="importGoods.dialog = false"> 取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VenderSelect from "@/components/appointment/VenderSelect";
import {default as ConfigApi} from "@/api/appointment/config/ConfigApi";
import ParkSelect from "@/components/appointment/ParkSelect";
import ParkApi from "@/api/appointment/park/ParkApi";
import CsApi from "@/api/appointment/orders/CsApi";
import {default as downloadUtil} from "@/util/downloadUtil";
import AppointmentApi from "@/api/appointment/orders/AppointmentApi";
export default {
  name: "AppointmentForm",
  components: {ParkSelect, VenderSelect},
  props: {
    formData:{
      type:Object
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      warning:'',
      rules:{
        required: value => (!!value || value === 0) || '必填.',
        number:value=> ((!value && value !== 0)||(!isNaN(parseFloat(value)) && value >= 0)) || '只能输入数字',
        appointDate:value=>this.formData.addType ==3 || !this.appointStartDate || !this.appointEndDate || (value >= this.appointStartDate && value<= this.appointEndDate) || '可预约日期：' + this.appointStartDate + ' ~ ' + this.appointEndDate
      },
      appointStartDate:null,
      appointEndDate:null,
      appointment:{
        sendStartTime:'',
        sendEndTime:'',
        scheduledDate:'',
        orderList:[],
        goodsList:[],
      },
      orderHeaders:[
        {text: '订单号', align: 'start', width:120,sortable: false, value: 'ordercode',},
        { text: '货品数', value: 'goodsCount',width: 120, sortable: false,},
        { text: '总件数', value: 'innums' ,width: 120, sortable: false,},
        { text: '总数量', value: 'denums' ,width: 120, sortable: false,},
        { text: '未发货数量', value: 'undeliveryNums' ,width: 120, sortable: false,},
        { text: '本次发货货品数', value: 'deliveryCount' ,width: 120, sortable: false,},
        { text: '本次发货数量', value: 'deliveryNum' ,width: 120, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:200 },
      ],
      order:{
        dialog:false,
        loading:false,
        selected:[],
        search:'',
        headers:[
          {text: '订单号', align: 'start', width:120,sortable: false, value: 'ordercode',},
          { text: '货品数', value: 'goodsCount',width: 120, sortable: false,filterable: false,},
          { text: '总件数', value: 'innums' ,width: 120, sortable: false,filterable: false,},
          { text: '总数量', value: 'denums' ,width: 120, sortable: false,filterable: false,},
          { text: '未发货数量', value: 'undeliveryNums' ,width: 120, sortable: false,filterable: false,},
          { text: '订单状态', value: 'status' ,width: 120, sortable: false,filterable: false,},
          { text: '有效期', value: 'sdate' ,width: 250, sortable: false,filterable: false,},
        ],
        desserts:[],
        overlay: false,
      },
      orderItem:{
        item:{},
        dialog:false,
        completeList:[{id:1,name:'是'},{id:0,name:'否'}]
      },
      goods:{
        dialog:false,
        loading:false,
        selected:[],
        search:'',
        headers:[
          {text: '商品名称', align: 'start', width:120,sortable: false, value: 'goodsname', filterable: true},
          { text: '商品条码', value: 'barcode',width: 120, sortable: false,filterable: true,},
          { text: '包装规格', value: 'packagespec',width: 120, sortable: false,filterable: true,},
          { text: '单位', value: 'pkname',width: 120, sortable: false,filterable: true,},
        ],
        desserts:[],
      },
      importGoods:{
        dialog:false,
        importFile: undefined,
      },
      auditHeaders:[
        {text: '审核结果', align: 'start', width:120,sortable: false, value: 'auditResult',},
        { text: '审核说明', value: 'rejectReason',width: 250, sortable: false,},
        { text: '审核人', value: 'auditBy' ,width: 120, sortable: false,},
        { text: '审核时间', value: 'auditTime' ,width: 120, sortable: false,},
      ],
      auditResultList:[{id:1,name:'通过'},{id:2,name:'不通过'}],
      dischargeTypeList:[],
      timeTypeList:[],
    }
  },
  watch:{
    'appointment.parkId'(val){
      this.parkChange(val);
    },
    'appointment.venderId'(val){
      this.appointment.orderList = [];
    }
  },
  created() {

    this.getDischargeTypeList();
    this.setTimeTypeList();
    if(this.formData.id){
      this.getAppointment();
    }
  },
  methods:{
    async getDischargeTypeList() {
      let resp = await AppointmentApi.dischargeType();
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取卸货方式列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      this.dischargeTypeList = data.data;
    },

    setTimeTypeList(){
      for(let i = 0; i < 24; i++){
        this.timeTypeList.push({id:i, name:i + '点-' + (i + 1) + '点'})
      }
    },
    back(){
      this.$emit("formCallback", {formStatus:'list'})
    },
    async parkChange(parkId) {
      this.appointment.sendStartTime = '';
      this.appointment.sendEndTime = '';
      if (parkId) {
        let resp = await ParkApi.detail({id: parkId});
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "获取配送中心失败" : msg;
          throw new Error(msg);
        }
        let park = data.data;
        this.appointment.sendStartTime = park.startTime;
        this.appointment.sendEndTime = park.endTime;
        this.appointStartDate = park.appointStartDate;
        this.appointEndDate = park.appointEndDate;
      }
    },
    async linkOrder() {
      if (!this.appointment.venderId) {
        this.$dialog.error({
          title: '错误',
          text: '请先选择供应商'
        });
        return;
      }
      if(!this.appointment.scheduledDate){
        this.$dialog.error({
          title: '错误',
          text: '请先选择预约日期'
        });
        return;
      }
      this.order.dialog = true;
      this.order.loading = true;
      this.order.desserts = [];
      this.order.search = '';
      this.order.selected = this.appointment.orderList;
      let resp = await CsApi.listOrd({venderId: this.appointment.venderId,scheduledDate:this.appointment.scheduledDate});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取订货通知单失败" : msg;
        throw new Error(msg);
      }
      this.order.desserts = data.data;
      this.order.loading = false;
    },
    async selectOrder() {
      let selectList = this.order.selected;
      let orderList = this.appointment.orderList ? this.appointment.orderList : [];
      let addList = [];
      selectList.forEach(select => {
        let has = false;
        orderList.forEach(order => {
          if (order.ordercode == select.ordercode) {
            has = true;
          }
        })
        if (!has) {
          addList.push(select);
        }
      });
      if(addList.length > 0){
        this.order.overlay = true;
        let resp = await CsApi.computerNum(addList);
        let data = resp.data;
        this.order.overlay = false;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "计算订货通知单数量失败" : msg;
          throw new Error(msg);
        }
        addList = [];
        let zeroList = [];
        data.data.forEach(add=>{
          if(add.undeliveryNums == 0){
            zeroList.push(add.ordercode);
          }else{
            addList.push(add);
          }
        })
        orderList = orderList.concat(addList);
        this.appointment.orderList = orderList;
        if (zeroList.length > 0){
          this.$dialog.info({
            title:'提示',
            text:zeroList.join(",") + "这些订单未发货数量为0，无法添加"
          })
        }
      }
      this.order.dialog = false;
    },
    watchOrderGoods(item){
      this.orderItem.item = item;
      this.orderItem.dialog = true;
    },
    innumsChange(innums, ordD){
      if(!isNaN(innums)){
        ordD.thisDenums = Math.round(ordD.num * innums);
      }
    },
    denumsChange(denums, ordD){
      if(!isNaN(denums)){
        ordD.thisInnums = (denums / ordD.num).toFixed(2);
      }
    },
    saveItem(){
      let valid = this.$refs.itemForm.validate();
      if(valid){
        let deliveryCount = 0;
        let deliveryNum = 0;
        for(let ordD of this.orderItem.item.itemList){
          if(ordD.thisInnums > ordD.undeliveryInnums || ordD.thisDenums > ordD.undeliveryDenums){
            this.$dialog.error({
              title:'错误',
              text:'商品（'+ordD.pn+')的本次发货数量不可超过未发货数量'
            })
            return;
          }
          if(ordD.thisDenums > 0){
            deliveryCount ++;
            deliveryNum += Number(ordD.thisDenums);
          }
        }
        this.orderItem.item.deliveryCount = deliveryCount;
        this.orderItem.item.deliveryNum = deliveryNum;
        let orderList = this.appointment.orderList;
        this.appointment.orderList = [];
        this.appointment.orderList = orderList;
        this.orderItem.dialog = false;

      }
    },
    deleteOrder(index){
      this.appointment.orderList.splice(index,1);
    },
    async linkGoods() {
      if (!this.appointment.venderId) {
        this.$dialog.error({
          title: '错误',
          text: '请先选择供应商'
        });
        return;
      }
      this.goods.dialog = true;
      this.goods.loading = true;
      this.goods.desserts = [];
      this.goods.search = '';
      this.goods.selected = this.appointment.goodsList;
      let resp = await CsApi.listGoods({venderId: this.appointment.venderId});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取商品失败" : msg;
        throw new Error(msg);
      }
      this.goods.desserts = data.data;
      this.goods.loading = false;
    },
    selectGoods() {
      let selectList = this.goods.selected;
      let goodsList = this.appointment.goodsList ? this.appointment.goodsList : [];
      let addList = [];
      selectList.forEach(select => {
        let has = false;
        goodsList.forEach(goods => {
          if (goods.goodsId == select.goodsId) {
            has = true;
          }
        })
        if (!has) {
          addList.push(select);
        }
      });
      addList.forEach(add=>{
        add.deliveryNum = 0;
      })
      goodsList = goodsList.concat(addList);
      this.appointment.goodsList = goodsList;
      this.goods.dialog = false;
    },
    deleteGoods(index){
      this.appointment.goodsList.splice(index,1);
    },
    doGoodsImport() {
      if (!this.appointment.venderId) {
        this.$dialog.error({
          title: '错误',
          text: '请先选择供应商'
        });
        return;
      }
      this.importGoods.dialog = true;
    },
    async downloadTemplate() {
      let fileName = '商品导入模板.xlsx';
      let res = await CsApi.goodsTemplate();

      downloadUtil.downloadByBlob({ res: res.data, fileName: fileName });
    },
    async handleImport() {
      let me = this;
      let file = me.importGoods.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await CsApi.importGoods(file, this.appointment.venderId);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        let selectList = res.data.data;
        let goodsList = this.appointment.goodsList ? this.appointment.goodsList : [];
        let addList = [];
        selectList.forEach(select => {
          let has = false;
          goodsList.forEach(goods => {
            if (goods.goodsId == select.goodsId) {
              has = true;
            }
          })
          if (!has) {
            addList.push(select);
          }
        });
        addList.forEach(add=>{
          add.deliveryNum = 0;
        })
        goodsList = goodsList.concat(addList);
        this.appointment.goodsList = goodsList;
      } else {
        me.$dialog.error({
          text: res.data.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
      }
      me.importGoods.dialog = false;
      me.importGoods.importFile = undefined;
    },
    async save() {
      let valid = this.$refs.appointmentForm.validate();
      if (valid) {
        let appointment = this.appointment;
        appointment.addType = this.formData.addType;
        if (appointment.addType == 2) {
          if(!appointment.boxNum && !appointment.tonNum){
            this.$dialog.error({
              title: '错误',
              text: '请输入总箱数或者吨数',
            })
            return;
          }
          if (!appointment.goodsList || !appointment.goodsList.length) {
            this.$dialog.error({
              title: '错误',
              text: '请关联或导入商品',
            })
            return
          }
          for (let goods of appointment.goodsList) {
            if (!goods.deliveryNum) {
              this.$dialog.error({
                title: '错误',
                text: '请输入商品发货数量',
              })
              return;
            }
          }
        } else {
          if (!appointment.orderList || !appointment.orderList.length) {
            this.$dialog.error({
              title: '错误',
              text: '请关联订单',
            })
            return;
          }
          for (let order of appointment.orderList) {
            if (!order.deliveryNum) {
              this.$dialog.error({
                title: '错误',
                text: '请在货品明细中输入发货数量',
              })
              return;
            }
          }
        }
        let resp;
        if(!this.appointment.id){
          resp = await AppointmentApi.insert(this.appointment);
        }else{
          resp = await AppointmentApi.update(this.appointment);
        }

        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "保存预约单失败" : msg;
          this.$dialog.error({
            title:'错误',
            text:msg
          })
        }else{
          this.$emit("formCallback", {formStatus:'list', refresh:true})
        }
      }
    },
    async getAppointment() {
      let resp = await AppointmentApi.get({id: this.formData.id});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预约单信息失败" : msg;
        throw new Error(msg);
      }
      this.appointment = Object.assign(this.appointment, data.data );

    },
  }
}
</script>

<style scoped>

</style>